import { LoginComponent } from './components/auth/login/login.component';
import { DefaultLayoutComponent } from './components/layout/default-layout/default-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ClientModelComponent } from './components/shared/client-model/client-model.component';
import { WorkDisplayComponent } from './components/dashboard/work-display-component/work-display.component';
import { SparklinesGridComponent } from './components/shared/charts/sparklines-Grid/sparklines-grid.component';
import { HelpCenterComponent } from './components/widget/help-center/help-center.component';
import { HierarchicalGridChartComponent } from './components/shared/charts/hierarchical-grid-chart/hierarchical-grid-chart.component';
import { ConfigTypeSelectionComponent } from './components/shared/config-type-selection/config-type-selection.component';
import { MultiLinechartComponent } from './components/widget/multi-linechart/multi-linechart.component';
import { AuthGuardGuard } from './services/auth-guard.guard';
import { HelpInformationComponent } from './components/widget/help-information/help-information.component';
import { StackedAreabarComponent } from './components/shared/charts/stacked-areabar/stacked-areabar.component';
import { WidgetPaymentSummaryComponent } from './components/widget/payment-summary/payment-summary.component';
import { EventScheduleComponent } from './components/shared/calendar-events/event-schedule/event-schedule.component';
import { ChartPreferencesFormlyComponent } from './components/shared/chart-preferences-formly/chart-preferences-formly.component';
import { CallbackComponent } from './components/auth/callback/callback.component';
import { MeetingJoinComponent } from './components/shared/calendar-events/meeting-join/meeting-join.component';
import { SecureMessagePageComponent } from './components/secure-message/secure-message-page.component';
import { VisitPlannerComponent } from './components/shared/visit-planner/visit-planner.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'callback',
    pathMatch: 'full',
    component: CallbackComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuardGuard]
  },
  {
    path: 'client',
    component: ClientModelComponent,
  },
  {
    path: 'config',
    component: ConfigTypeSelectionComponent,
  },

  {
    path: "EVENTS",
    component: EventScheduleComponent,
  },
  {
    path: "Events",
    component: EventScheduleComponent,
  },
  {
    path: "events",
    component: EventScheduleComponent,
  },
  {
    path: "meeting/join/:code",
    component: MeetingJoinComponent,
  },
  {
    path: "secure/m/:token",
    component: SecureMessagePageComponent,
  },
  {
    path: "visit-planner",
    component: VisitPlannerComponent,
  },
  {
    path: "VISIT-PLANNER",
    component: VisitPlannerComponent,
  },
  {
    path: "test",
    component: ChartPreferencesFormlyComponent,
  },
  // {
  //   path: "help",
  //   component: HelpInformationComponent,
  // },
  // {
  //   path: "payment",
  //   component: HierarchicalGridChartComponent,
  // },
  {
    path: "work/:workKey/:version",
    component: WorkDisplayComponent,
  },
  {
    path: 'auth',
    component: DefaultLayoutComponent,
    loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule),
  },
  {
    // Shared empty-path parent so DefaultLayoutComponent (sidebar) is reused, not recreated, across dashboard/direct/du-admin.
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuardGuard],
        loadChildren: () => import('./components/dashboard/dashbaord.module').then(m => m.DashboardModule),
      },
      {
        path: 'direct',
        canActivate: [AuthGuardGuard],
        loadChildren: () => import('./components/direct/direct.module').then(m => m.DirectModule),
      },
      {
        path: 'du-admin',
        canActivate: [AuthGuardGuard],
        loadChildren: () => import('./components/du-admin/du-admin.module').then(m => m.DuAdminModule),
      },
    ],
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking' // msal
    })
  ],
  exports: [
    RouterModule
  ],
  providers: [AuthGuardGuard]
})
export class AppRoutingModule { }
